<i class="fa fa-times close" mat-dialog-close aria-hidden="true"></i>
<h3 mat-dialog-title i18n>Biztosan törli az eddig felvitt adatokat?</h3>
<mat-dialog-content class="mat-typography">
    <div class="modifyWindowForm form-inline mt-3">
        <button (click)="deleteCaseValues(true)" i18n>igen</button>
        <button  mat-dialog-close i18n>nem</button>
    </div>
</mat-dialog-content>
